import React, { Component } from 'react';
import { DataMotifArchivage } from '../../data/DataMotifArchivage';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxMotifArchivage extends Component {

    static defaultProps = {
        label: "Motif d'archivage",
        placeholder: "Motif d'archivage",
    };

    render = () => {

        return <EUIComboBox
            {...this.props}
            fetchMethod={DataMotifArchivage._chargementDesMotifArchivages}
            idValeurParDefaut="0"
            itemKey={item => item.idMotifArchivage}
            itemText={item => item.libelle}
        />;

    };

};